import { inject, Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  // private loaderSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // loading$ = this.loaderSubject$.asObservable();
  private spinnerService = inject(NgxSpinnerService);
  private apiCount = 0;

  show() {
    if (this.apiCount === 0) {
      this.spinnerService.show();
    }
    this.apiCount++;
  }

  hide() {
    this.apiCount--;
    if (this.apiCount === 0) {
      this.spinnerService.hide();
    }
  }

}
